import { render, staticRenderFns } from "./SuiModal.vue?vue&type=template&id=1a9b2532&"
import script from "./SuiModal.vue?vue&type=script&lang=js&"
export * from "./SuiModal.vue?vue&type=script&lang=js&"
import style0 from "./SuiModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports